import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import stringify from 'json-stable-stringify';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { getDefaultHeaderObj } from '../../../request-contract-helper';

// FIXME: Extract consts and utils in @bingads-webui-campaign-react/smart-app-capi into two packages
// The mapping is copied from @bingads-webui-campaign-react/smart-app-capi
// We cannot simply import it due to some dependecies incompatible with react-native
const currencyMapping = {
  ars: 'ArgentinePeso',
  aud: 'AustralianDollar',
  brl: 'BrazilianReal',
  cad: 'CanadianDollar',
  chf: 'SwissFranc',
  clp: 'ChileanPeso',
  cny: 'YuanRenminbi',
  cop: 'ColombianPeso',
  dkk: 'DanishKrone',
  dzd: 'AlgerianDinar',
  egp: 'EgyptianPound',
  eur: 'Euro',
  gbp: 'UKPound',
  hkd: 'HongKongDollar',
  idr: 'IndonesianRupiah',
  inr: 'IndianRupee',
  jpy: 'JapaneseYen',
  lbp: 'LebanesePound',
  mad: 'MoroccanDirham',
  mex: 'MexicanPeso',
  myr: 'MalaysianRingit',
  nok: 'NorwegianKrone',
  nzd: 'NewZealandDollar',
  pen: 'PeruvianNuevoSol',
  php: 'PhilippinePeso',
  qar: 'QatariRiyal',
  sar: 'SaudiRiyal',
  sek: 'SwedishKrona',
  sgd: 'SingaporeDollar',
  thb: 'ThaiBaht',
  twd: 'NewTaiwanDollar',
  usd: 'UsDollar',
  vef: 'VenezuelanBolivar',
  vnd: 'VietnamDong',
  zar: 'SouthAfricanRand',
};

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
  } = variables;
  const { descriptor } = locator;
  const { cid, aid, campaignId } = descriptor;

  if (!campaignId) {
    throw new Error('Kpi estimation function call need campaign Id');
  }

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId);

  return `${entity.path}/KpiEstimations`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function odataPayloadFactory(params) {
  const { variables } = params;
  const {
    currencyId,
  } = variables;

  return {
    Currency: currencyMapping[currencyId],
  };
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign:kpi_estimations',
  verb: requestVerbs.POST,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  payloadFactoryFn: odataPayloadFactory,
  keySelector: chartData => chartData.ClientId,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: chartData => chartData.ClientId,
  processorFn: (response, request) => ({
    ...response,
    ClientId: stringify(request.variables),
  }),
});
